import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import { Collapse } from 'antd'
import ProgressQueueModels from 'ecp/models/ProgressQueueModels'
import useProgressQueue from 'hooks/useProgressQueue'
import React, { useEffect } from 'react'
import { IProgressQueueItem } from 'store/modules/progressQueue/progressQueueReducer'
import { IProgressQueueInfo, IProgressQueueInfoStatus } from '../../progressQueueInterfaces'
import ProgressQueueCardView from '../ProgressQueueCardView/ProgressQueueCardView'

type Props = {
  queueItem: IProgressQueueItem
  itemIndex: number
  queueList: IProgressQueueItem[]
}

type ICardBodyProps = {
  progressQueueInfoList: IProgressQueueInfo[]
}

function CardBody ({ progressQueueInfoList }: ICardBodyProps) {
  function handleItemLabelClassName (status: IProgressQueueInfoStatus) {
    if (status === 'finish') return 'color-approved'
    if (status === 'error') return 'color-refused'
  }

  return (
    <Collapse bordered={false}>
      {Array.isArray(progressQueueInfoList) && progressQueueInfoList.map((item, index) => {
        return (
          <Collapse.Panel
            header={
              <div className='flex flex-space-between'>
                <label className={handleItemLabelClassName(item.status)}>
                  <b className='text-ellipsis'>Relatório</b>
                </label>

                {item.status === 'finish'
                  ? <CheckCircleFilled className='color-approved mt-1'/>
                  : <CloseCircleFilled className='color-refused mt-1'/>
                }
              </div>
            }
            key={index}
          >
            <p className={`progress-queue-card__message ${handleItemLabelClassName(item.status)} mb-2`}>
              <b>{item.errorMessage ? item.errorMessage : item.succesMessage}</b>
            </p>

            <p className={`progress-queue-card__message ${handleItemLabelClassName(item.status)}`}>
              {item.info}
            </p>

            {item.link?.path &&
              <a
                target='_blank'
                className={`link-style ${handleItemLabelClassName(item.status)} font-500 mb-0 table-name`}
                href={item.link.path}
                rel="noreferrer"
              >
                {item.link.text}
              </a>
            }
          </Collapse.Panel>
        )
      })}
    </Collapse>
  )
}

export default function ProgressQueueCardReports ({ queueItem, itemIndex, queueList }: Props) {
  const {
    removeProgressQueueItem, progressQueueProgressCheckReports
  } = useProgressQueue()

  const {
    isImporting, progressCheckId,
    listLenght, progressQueueInfoList,
    percentage, status, type, action
  } = queueItem

  useEffect(() => {
    const abortController = new AbortController()
    const progressCheck = setInterval(async () => {
      if (isImporting) {
        progressQueueProgressCheckReports(abortController, progressCheckId, itemIndex)
      }
    }, 4500)

    return () => {
      abortController.abort()
      clearInterval(progressCheck)
    }
  }, [isImporting, itemIndex])

  return (
    <>
      <ProgressQueueCardView
        onClose={removeProgressQueueItem}
        percentage={percentage ?? 0}
        status={status}
        listLenght={listLenght}
        progressQueueInfoList={progressQueueInfoList}
        progressText={ProgressQueueModels.progressQueueText({ selectedRowsLenght: listLenght, status: status, type, action })}
        itemIndex={itemIndex}
        queueList={queueList}
        body={ <CardBody progressQueueInfoList={progressQueueInfoList || []}/>}
      />
    </>
  )
}
